/* Scope verified USD Shopify price leaves for the display-only currency engine. */
(() => {
  'use strict';
  if (window.Shopify?.currency?.active !== 'USD') return;
  const SELECTORS = [
    '.money',
    '.km-product__price',
    '.shop-product-price-block',
    '.shop-compare-price',
    '.price-item',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.cart-item__price-wrapper .price--end',
    '.totals__total-value',
    '.discounts__amount'
  ].join(',');
  const USD = /^\s*(?:USD\s*)?\$\s*(?:[0-9]{1,3}(?:,[0-9]{3})*|[0-9]+)(?:\.[0-9]{2})?\s*(?:USD)?\s*$/i;
  let authorized = false;
  let queued = false;
  function mark() {
    if (!authorized) return;
    for (const node of document.querySelectorAll(SELECTORS)) {
      if (node.children.length || node.closest('button, a, label, input, textarea, select, iframe')) continue;
      if (!USD.test(node.textContent || '')) continue;
      node.setAttribute('data-lv-money', 'usd');
    }
    window.AWLocalCurrency?.scan?.(document);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; mark(); });
  }
  fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
    .then(response => response.ok ? response.json() : null)
    .then(cart => {
      if (cart?.currency !== 'USD') return;
      authorized = true;
      mark();
      new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true });
    })
    .catch(() => {});
})();
